import {React} from 'common'
import Menu from '@mui/material/Menu'
import {getSupportedLanguages} from 'localization/i18n'
import LanaguageButton from 'components/Control/LanaguageButton'
import {Styles} from 'appearance'

const LanguageMenu = ({languageAnchorEl, setLanguageAnchorEl}) => {
    const isLanguageMenuOpen = Boolean(languageAnchorEl)

    const handleLanguageMenuClose = () => {
        setLanguageAnchorEl(null)
    }

    const languageMenuId = 'primary-search-account-menu-language'

    return (
        <Menu
            anchorEl={languageAnchorEl}
            anchorOrigin={Styles.MENU_ANCHOR_ORIGIN}
            id={languageMenuId}
            keepMounted
            open={isLanguageMenuOpen}
            onClose={handleLanguageMenuClose}>
            {getSupportedLanguages().map((lang) => {
                return (
                    <LanaguageButton
                        key={`lang_${lang}`}
                        isPopUp
                        language={lang}
                        close={handleLanguageMenuClose}
                    />
                )
            })}
        </Menu>
    )
}

export default LanguageMenu
